import lang from 'dojo/_base/lang';
import { compose, mdsWidget, mdsLazyProto } from 'dojo/_base/declare';
import topic from 'dojo/topic';
import dijitRegistry from 'dijit/registry';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import aspect from 'dojo/aspect';
import { TabContainer } from "../../_loadingHelpers/Tabbing"
import "./TabbingTypes";
import { TranslationHelpers } from "../../../more/Helpers";
//import DataItems = require("DataItems");

/**
 * Interface für das Widget das die Vererbungslinie angibt um die korrekten Typings zu setzen
 */
type _TabEnabledMixin__mdsbase = InstanceType<typeof _WidgetBaseSP>;
interface _TabEnabledMixin extends _TabEnabledMixin__mdsbase{ }
export default function _TabEnabledMixin(__Base: any) {
  const __C = 
class _TabEnabledMixin extends __Base {

    isEmbeddedInTab: boolean;
    isActivatedTab: boolean;

    protected enablingListener: Function;


    // tab-spezifisch Config
    title: string;
    internalName: string;
    iconclass: string;
    showInSidebar: boolean;
    order: number;
    tabColor: string;
    enableClosing: boolean;

    private targetContainerName: string;
    private hasPrivilege: boolean;
    private hasFeat: boolean;
    private __tabEnabledMixin_StartupDone: boolean;
    protected _tabContainer: MdsLax<InstanceType<typeof TabContainer>>;

    private _setEmbedIntoContainerAttr(containerName: string) {
        this.targetContainerName = containerName;
    }

    private _setPrivilegeNeededAttr(name: string) {
        if (!name) {
            this._onPrivilegeCheck(true);
        } else {
            this.hasPrivilege = null;
            this.hasUserRole(name, lang.hitch(this, this._onPrivilegeCheck));
        }
    }
    private _setFeatureNeedeAttr(featurepath: string) {
        this._setFeaturePathAttr(featurepath);
    }
    private _setFeaturePathAttr(featurepath: string) {
        if (featurepath) {
            this.hasFeat = this.hasFeature(featurepath);
            this._tryEmbedding();
        } else {
            this.hasFeat = true;
        }
    }

    private _onPrivilegeCheck(result: boolean) {
        this.hasPrivilege = !!result;
        this._tryEmbedding();
    }

    private _tryEmbedding(): boolean {
        let check = this.hasPrivilege && this.hasFeat;

        if (this.__tabEnabledMixin_StartupDone && this.hasPrivilege != null) {
            if (check) {
                if (this.targetContainerName) {
                    this.embedAsTab(this.targetContainerName);
                }
            } else {
                if (this.isEmbeddedInTab) {
                    this.closeTab();
                } else {
                    this.hideNode(this.domNode);
                    setTimeout(lang.hitch(this, this.destroy), 10); //shitty hotfix agendaView
                }

                return false;
            }
        }

        return this.isEmbeddedInTab;
    }

    // lustig: die Funktion darf nicht embedIntoContainer heißen, sonst script-Fehler. vermutlich dojo-Konflikt.
    embedAsTab(containerOrName: string | MdsLax<InstanceType<typeof TabContainer>>) {
        if (typeof (containerOrName) === "string") {
            this.targetContainerName = containerOrName;

            if (this.hasPrivilege && this.hasFeat/* && this.domNode?.isConnected === true*/) {
                this.placeIntoTabContainer();
            }
        } else {
            if (this.hasPrivilege && this.hasFeat/* && this.domNode?.isConnected === true*/) {
                this.placeIntoTabContainer(containerOrName);
            }
        }
    }
    getContainerName(widget?: dijit._WidgetBase, maxLookupLevel?: number): string {
        return this.getTabContainerName(widget, maxLookupLevel);
    }
    private placeIntoTabContainer(container?: MdsLax<InstanceType<typeof TabContainer>>): void {
        if (!this.targetContainerName) return;
        if (this.isEmbeddedInTab === true) return;
        if (!this.hasPrivilege) return;
        if (!this.hasFeat) return;

        if (container) {
            this._tabContainer = container;
            this.targetContainerName = this.getTabContainerName();
            container.placeWidgetIntoTab(this);
            return;
        }

        // sich beim TabContainer melden, der soll mich bitte einbinden
        let widgets = dijitRegistry._hash;
        for (let widgetName in widgets) {
            let widget = widgets[widgetName];
            if (widget.declaredClass == "TabContainer") {
                if (widget.name == this.targetContainerName) {
                    widget.placeWidgetIntoTab(this);
                    this._tabContainer = widget;
                }
            }
        }
    }
    /**
     * Einen kontextbezogenen Tabbutton erstellen, der entweder permanent oder bei Aktivierung des Parent-Tabs angezeigt wird
     * Hinweis: Coloration kann ein Hex-Wert oder eine Styleklasse sein (tatsächliche Färbung wird extrahiert)
     * @param requestData Konfigurationsparameter inklusive Beschriftung und Callback
     */
    protected requestContextButton(requestData: Tabbing.ContextActionButtonRequest): Tabbing.ContextActionButtonDescriptor {
        //if (requestData.label === "test") console.log(requestData);
        return this.createContextButton(requestData);
    }

    protected requestContextButtonRemove(buttonName: string) {
        this.emit("requestRemoveContextButton", buttonName);

        let index = this._createdDefaultButtons?.indexOf(buttonName);
        while (index != -1) {
            if (index > -1) this._createdDefaultButtons.splice(index, 1);
            index = this._createdDefaultButtons?.indexOf(buttonName);
        }
    }

    protected requestContextButtonDisable(buttonName: string, bEnable: boolean = false) {
        this.emit("requestDisableContextButton", { name: buttonName, enable: bEnable });
    }
    protected requestContextButtonEnable(buttonName: string, bEnable: boolean = true) {
        this.requestContextButtonDisable(buttonName, bEnable !== false);
    }

    /**
   * Einen kontextbezogenen Tabbutton erstellen, der entweder permanent oder bei Aktivierung des Parent-Tabs angezeigt wird
   * Hinweis: Coloration kann ein Hex-Wert oder eine Styleklasse sein (tatsächliche Färbung wird extrahiert)
   * @param requestData Konfigurationsparameter inklusive Beschriftung und Callback
   */
    protected createContextButton(requestData: Tabbing.ContextActionButtonRequest): Tabbing.ContextActionButtonDescriptor {

        //this.emit("requestNewContextButton", requestData);
        if (!requestData.order) {
            requestData.order = 666;
        }

        if (this._tabContainer) {
            return this._tabContainer.createContextButton(this, requestData);
        } else {
            this.emit("requestNewContextButton", requestData);
        }
        return null;
    }

    protected _createdDefaultButtons: Array<string>;
    /**
     * Einen kontextbezogenen NEU-Button erstellen.
     * Label und Farbe werden ignortiert.
     * Die Konfiguration wird im Hintergrund so standardisiert, dass das Label gleichbleibend ist.
     * @param requestData Konfigurationsparameter inklusive Beschriftung und Callback
     * @param initialEnabledState
     */
    protected createDefaultButton(type: Tabbing.DefaultButtonName, callback: Function,
        initialEnabledState: boolean = true, overwritePlacement?: Tabbing.ButtonPlacement, overrideLabel?: string) {

        //if (!this.isEmbeddedInTab) return;

        if (type == "deleteWithConfirmationDlg") {
            // dann packen wir das Callback in eine Standardmethode mit GenericDlg:
            let newCallback = lang.hitch(this, this._defaultDeleteCallbackDlg, callback, null);
            callback = newCallback;
            type = "delete";
        }

        if (type == "copy") type = "clone";

        if (this._createdDefaultButtons.indexOf(type) != -1) return;


        let permanent = false;
        let label = "";
        let styleclass = null;
        let iconClass: string = "";
        let icon: HTMLElement = null;
        let placement: Tabbing.ButtonPlacement = "actionbar";
        let order = 99;
        switch (type) {
            case "new":
                permanent = false;
                iconClass = "fas fa-plus-circle";
                label = this.translate("General_CreateNew");
                placement = "top";
                order = 0;
                styleclass = "primary"
                break;

            case "send":
                permanent = false;
                iconClass = "fas fa-paper-plane";
                label = this.translate("General_Label_Send");
                order = 8;
                break;

            case "save":
                permanent = false;
                iconClass = "fas fa-save";
                label = this.translate("General_Save");
                order = 10;
                break;

            case "rollback":
                permanent = false;
                iconClass = "fas fa-undo";
                label = this.translate("General_Rollback");
                placement = "primarymenu";
                order = 12;
                break;

            case "clone":
            //case "copy":
                permanent = false;
                iconClass = "fas fa-clone";
                label = this.translate("General_Copy");
                placement = "primarymenu";
                order = 15;
                break;
            case "delete":
                permanent = false;
                iconClass = "fas fa-trash warningTXT";
                label = this.translate("General_Delete");
                placement = "primarymenu";
                order = 999;
                break;
            case "reload":
                permanent = false;
                iconClass = "fas fa-sync";
                label = this.translate("General_Label_Reload");
                order = 20;
                break;
            case "edit":
                permanent = false;
                iconClass = "fas fa-edit";
                label = this.translate("General_Edit");
                order = 30;
                styleclass = "accentBG";
                callback = lang.hitch(this, this._onClickEditButton, callback);

                break;
            case "deactivate":
                permanent = false;
                iconClass = "fas fa-power-off"
                label = this.translate("General_SetAsInactive");
                placement = "actionmenu";
                order = 998;
                // den anderen suchen und rauswerfen:
                this.requestContextButtonRemove("activate");
                break;
            case "activate":
                permanent = false;
                iconClass = "fas fa-power-off"
                label = this.translate("General_SetAsActive");
                placement = "actionmenu";
                order = 998;
                // den anderen suchen und rauswerfen:
                this.requestContextButtonRemove("deactivate");
                break;
            default:

                return;
                break;
        }

        if (overwritePlacement) {
            placement = overwritePlacement;
        }

        if (overrideLabel) {
            label = overrideLabel;
            label = TranslationHelpers.tryTranslate(label);
        }

        let config: Tabbing.ContextActionButtonRequest = {
            callback: callback,
            permanent: permanent,
            placement: placement,
            label: label,
            iconClass: iconClass,
            styleClass: styleclass,
            enabled: initialEnabledState,
            order: order,
            isDefault: true
        };



        config["_defaultType"] = type;

        this._createdDefaultButtons.push(type);

        if (this._tabContainer) {
            this._tabContainer?.createContextButton(this, config);
        } else {
            config.name = type;
            this.emit("requestNewContextButton", config);
            return;
        }

        // Runde zwei: manche Buttons platzieren sich in der unteren schwebenden Leiste

        let bottomConfig = { ...config };
        bottomConfig["_defaultType"] = type;

        bottomConfig.placement = "bottombar";
        bottomConfig.heading = label;
        switch (type) {
            //case "new":
            //    this.emit("requestNewContextButton", bottomConfig);
            //    break;
            case "new":
            case "save":
            case "send":
            case "edit":
            //case "reload":
            //case "reload":

                //this.emit("requestNewContextButton", bottomConfig);
                this._tabContainer?.createContextButton(this, bottomConfig);
                break;

            default:

                return;
                break;
        }
    }

    protected createDefaultMenuGroup(type: Tabbing.DefaultButtonGroupName) {
        let name = "";
        let label = "";
        let iconClass = "";
        let hasNextLevel = null;
        let parentGroupName = null;


        switch (type) {
            case "navigate":
                name = "navigate";
                label = this.translate("PrimaryMenu_Default_Group_Label_Navigate")
                iconClass = "fas fa-directions"
                hasNextLevel = true;
                break;
            case "reports":
                name = "reports";
                label = this.translate("General_Label_Reports");
                iconClass = "fas fa-print";
                hasNextLevel = true;
                break;
        }

        let groupConfig: Tabbing.PrimaryMenuGroupRequest = {
            name: name,
            label: label,
            iconClass: iconClass,
            hasNextLevel: hasNextLevel,
            parentGroupName: parentGroupName
        }

        this.createMenuGroup(groupConfig);
    }

    protected createMenuGroup(groupConfig: Tabbing.PrimaryMenuGroupRequest) {

        if (this._tabContainer) {
            this._tabContainer?.createMenuGroup(this, groupConfig);
        } else {
            this.emit("requestNewMenuGroup", groupConfig)
        }
    }

    protected _defaultDeleteCallbackDlg(actualCallback: Function, dlgResult: number = null) {
        // beim Klick auf Delete kommen wir mit result NULL hierher:

        if (dlgResult == null) {
            //let dlg = new GenericDialog();
            //dlg.show(this.translations["General_ConfirmDeleteMessage"],
            //    this.translations["General_Delete"] + " - " + this.title,
            //    null,
            //    "fas fa-trash",
            //    "yesno",
            //    lang.hitch(this, this._defaultDeleteCallbackDlg, actualCallback)
            //);
            //return;
            import("moreCore/UI/GenericDialog/GenericDialog").then(
                (__m: any) => (lang.hitch(this, this._isolatedDeleteDlg, actualCallback) as dojo.GenericFunction<void>)(__m.default !== undefined ? __m.default : __m));

            return;
        } else { // nach dem Dlg kommen wir mit einem Result hierher und können abbrechen oder das eigentliche Callback ausführen:
            if (dlgResult <= 0) {
                return;
            } else {
                actualCallback();
            }
        }
    }

    private _isolatedDeleteDlg(actualCallback, GenericDialog) {
        let dlg = new GenericDialog();
        dlg.show(this.translations["General_ConfirmDeleteMessage"],
            this.translations["General_Delete"] + " - " + this.title,
            null,
            "fas fa-trash",
            "yesno",
            lang.hitch(this, this._defaultDeleteCallbackDlg, actualCallback)
        );
    }

    protected _onClickEditButton(realCallback: Function) {
        this.emit("requestRemoveContextButton", "edit");
        realCallback();
    }

    protected getContextButtonConfig(name: string | Tabbing.DefaultButtonName): Tabbing.ContextActionButtonDescriptor {
        if (!name) return null;
        if (!this.internalName) return null;
        let page = this._tabContainer.getTabByName(this.internalName);
        if (page?.contextButtons) {
            for (let btn of page.contextButtons) {
                if (btn.name == name) {
                    return btn;
                } else if (btn["_defaultType"] == name) {
                    btn.name = name;
                    return btn;
                }
            }
        }
        return null;
    }

    protected updateContextButton(name: string, newConfig: Partial<Tabbing.ContextActionButtonRequest>) {
        if (!name) return;

        let existingBtn = this.getContextButtonConfig(name);
        if (!existingBtn) return;

        let newReqest = {
            ...existingBtn,
            ...newConfig
        };

        this.requestContextButtonRemove(name);
        this.requestContextButton(newReqest);
    }

    private _setTitleAttr(title: string) {
        title = TranslationHelpers.tryTranslate(title);
        this.title = title;


    }

    private _setShowInSidebarAttr(bShow?: boolean) {
        this.showInSidebar = bShow !== false;
    }

    /**
     * Fragt beim Tabcontainer eine Umbenennenung des eigenen Tabs an.
     * (Alias für changeTabTitle)
     * @param newTitle
     */
    requestTabRename(newTitle: string) {
        this.changeTabTitle(newTitle);
    }

    /**
     * Fragt beim Tabcontainer eine Umbenennenung des eigenen Tabs an.
     * * (Alias für requestTabRename)
     * @param newTitle
     */
    changeTabTitle(newTitle: string) {
        this._setTitleAttr(newTitle);

        this.emit("requestTabRename", this.title);

    }

    changeTabColor(newColor: string | more.EntityAPIColor) {
        if (newColor && typeof (newColor) == "string") {
            this.tabColor = "#" + newColor.replace("#", "");
        } else if (newColor && typeof (newColor) == "object") {
            this.tabColor = newColor.BackColor.IsNull ? null : newColor.BackColor.Hex;
        }

        if (this.isEmbeddedInTab) {
            this.emit("requestTabRecolor", this.tabColor);
        }
    }

    _onActivated() {
        /*this.setTitles(this.title);*/
    }

    _onHide() {

    }

    _onEmbedding(pageConfig: Tabbing.TabContainerPage, containerName: string) {
        this.targetContainerName = containerName;
    }

    closeTab() {
        if (!this.isEmbeddedInTab) return;
        topic.publish("/Tabbing/TabClosed", this.internalName);
    }

    _onClosing() {
        this.emit("tabClosed", this.internalName);
    }

    /** Wird bei Schließen des Tabs aufgerufen, kann eine beliebige Prüfung mit boolean-Ergebnis sein, damit der Tabcontainer über das tatsächliche Schließen entscheidet. */
    _onCloseRequest(): boolean {
        // Hinweis: wir können hier im Mixin keinen GenericDlg für einen standardisierten Warndialog einbinden, weil das Mixin nicht passt
        return true;
    }

    requestTabswitch(targetTabname: string) {
        this.emit("requestSwitchTab", targetTabname);
    }

    requestNewTabbedContent(tabdescriptor: Tabbing.TabPageDescriptor, activate?: boolean) {
        //if (!this.tabContainer) return false;

        //this.tabContainer.createTab(tabdescriptor);
        if (!this.isEmbeddedInTab) {
            this.createNewTabbedContent(tabdescriptor, activate, true);
        } else {
            this.emit("requestNewTab", tabdescriptor);
        }

        if (activate === true)
            this.requestTabswitch(tabdescriptor.name);
    }
    /**
     * Stellt den Fenster- und Navigationstitel ein. Für Getabbte Elemente wird der Navigationstitel auch für die Tabschaltfläche verwendet
     * @param windowTitle
     * @param topBarTitle
     */
    setTitles(windowTitle?: string, topBarTitle?: string) {
        windowTitle = TranslationHelpers.tryTranslate(windowTitle);
        topBarTitle = TranslationHelpers.tryTranslate(topBarTitle);

        if (!this.hasFeat || !this.hasPrivilege ) return;

        let self: any = this;
        super.setTitles.apply(this, arguments as any);



        // Hinweis: Leerstring "" zulassen. nur undefined und null sollen als "ich will einen Ersatzwert" gelten
        let title = topBarTitle;
        if (typeof (topBarTitle) == "undefined" || topBarTitle == null) {
            title = windowTitle;
        }

        if (typeof(title) != "undefined") {
            this.title = title;
        }


        if (this.isEmbeddedInTab) {
            this.changeTabTitle(this.title);
        }

    }

    busyStart() {
        this.emit("busyStart");
    }

    busyEnd() {
        this.emit("busyEnd");
    }

    emitDirty(bDirty: boolean = true) {
        this.emit("dirty", bDirty);
    }

    private _afterStandbyStart(args) {
        this.busyStart();
    }

    private _afterStandbyStop(args){
        this.busyEnd();
    }

    postCreate() {
        let self: any = this;
        super.postCreate.apply(this, arguments as any);

        this._createdDefaultButtons = [];

        this.placeIntoTabContainer();

        aspect.after(this, "StandbyStart", lang.hitch(this, this._afterStandbyStart));
        aspect.after(this, "StandbyStop", lang.hitch(this, this._afterStandbyStop));
        aspect.after(this, "StandbyEnd", lang.hitch(this, this._afterStandbyStop));
    }

    _setOrderAttr(targetOrder: number) {
        // ... mit dieser Reihenfolge
    }

    postMixInProperties(): void {
        let self: any = this;
        super.postMixInProperties.apply(this, arguments as any);
    }

    startup(): void {
        if (!this.__tabEnabledMixin_StartupDone) {
            let self: any = this;
            super.startup.apply(this, arguments as any);

            this.__tabEnabledMixin_StartupDone = true;

            this._tryEmbedding();
        }
    }

}

;
Object.assign(__C.prototype, {
  isEmbeddedInTab: false,
  isActivatedTab: false,
  title: "",
  internalName: "",
  iconclass: "",
  showInSidebar: false,
  order: 1,
  tabColor: "",
  enableClosing: false,
  targetContainerName: null,
  hasPrivilege: true,
  hasFeat: true,
  __tabEnabledMixin_StartupDone: false,
  _createdDefaultButtons: [],
  declaredClass: '_TabEnabledMixin',
});
  return __C;
}
Object.assign(_TabEnabledMixin, { __mdsMixinFactory: true, __mdsSpineBases: [_WidgetBaseSP] });
